import React from 'react'
import { Button } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'

export const DownloadButton = (buttonProps) => {
    const save = () => {
        // alert
        alert('Téléchargement en cours…')
    }
    return (
        <Button startIcon={<DownloadIcon />} onClick={save} {...buttonProps}>
            Télécharger
        </Button>
    )
}
